import script from "./DTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DTable.vue?vue&type=script&setup=true&lang=js"

import "./DTable.vue?vue&type=style&index=0&id=0a4604a2&lang=css"

const __exports__ = script;

export default __exports__